<ion-grid
  class="block-header-container"
  [style.background-color]="'var(--ion-color-' + backgroundColor + ')'"
>
  <ion-row class="ion-align-items-center ion-no-padding">
    <!-- Left block: Icon + Title -->
    <ion-col size="auto" class="ion-no-padding">
      <ion-row class="ion-align-items-center ion-no-padding">
        <ion-icon
          *ngIf="iconName"
          [name]="iconName"
          [color]="iconTitleColor"
          class="block-header-icon"
        ></ion-icon>

        <ion-label [color]="iconTitleColor" class="block-header-title">
          {{ title }}
        </ion-label>
      </ion-row>
    </ion-col>

    <!-- Right block: Action buttons -->
    <ion-col size="auto" class="ion-no-padding">
      <ion-row class="ion-align-items-center ion-no-padding">
        <ion-buttons class="block-header-actions">
          <ion-button
            *ngIf="showIconInfo"
            (click)="onInfoClick()"
            class="block-header-action-btn"
          >
            <ion-icon
              name="getm-information-outline"
              color="getm-neutral-dark"
            ></ion-icon>
          </ion-button>

          <ion-button
            *ngIf="showIconArrow"
            (click)="onArrowClick()"
            class="block-header-action-btn"
          >
            <ion-icon
              [name]="arrowIconName"
              color="getm-neutral-dark"
            ></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-row>
    </ion-col>
  </ion-row>
</ion-grid>
